import { useService } from "modules/Booking/common/hooks"
import { useBookingContext } from "modules/Booking/BookingContext"
import { useOnlyFreeSessions } from "pages/FreePsysPage/useOnlyFreeSessions"

export function NotAvailableSessionsText() {
    const onlyFree = useOnlyFreeSessions()
    const [{ onlineOrOffline, psy }] = useBookingContext()
    const { onlineAndOfflineAvailable } = useService()

    const text = (function () {
        if (onlyFree) {
            return "Психолог принимает только онлайн"
        }

        if (onlineOrOffline === "online" && !onlineAndOfflineAvailable) {
            if (psy.experiment_group) {
                return "Психолог принимает по видеосвязи"
            } else {
                return "Психолог принимает по Zoom / Skype / Google Hangouts"
            }
        }
    })()

    return <>{text && <div className="session-date__one-option">{text}</div>}</>
}
